/**
 * Разбивает одномерный массив на массив подмассивов (чанки) заданного размера.
 *
 * @template T - Тип элементов исходного массива.
 * @param {T[]} array - Исходный массив для разделения.
 * @param {number} size - Максимальный размер каждого чанка (должен быть больше 0).
 * @returns {T[][]} Новый двумерный массив, состоящий из подмассивов заданной длины.
 *
 * @example
 * const data =;
 * const result = chunkArray(data, 2);
 * // Результат: [[1, 2], [3, 4], [5]]
 */
export const chunkArray = (array: any[], size: number) => {
  return array.reduce((acc, item, index) => {
    const chunkIndex = Math.floor(index / size)
    if (!acc[chunkIndex]) {
      acc[chunkIndex] = []
    }
    acc[chunkIndex].push(item)
    return acc
  }, [])
}

/**
 * Создает копию массива, ограниченную указанной максимальной длиной.
 *
 * @template T - Тип элементов, содержащихся в массиве.
 * @param {T[]} arr - Исходный массив для обрезания.
 * @param {number} maxLength - Максимально допустимое количество элементов.
 * @returns {T[]} Новый массив, содержащий элементы от начала до maxLength.
 *
 * @example
 * const source =;
 * const result = truncateArray(source, 3); // [1, 2, 3]
 */
export function truncateArray<T>(arr: T[], maxLength: number): T[] {
  return arr.slice(0, maxLength)
}

export function formatPhoneNumber(phoneString: string) {
  // Очищаем строку от всех символов, кроме цифр
  let cleaned = phoneString.replace(/\D/g, '')

  // Если номер начинается с 8, меняем её на 7 для соответствия формату +7
  if (cleaned.startsWith('8')) {
    cleaned = '7' + cleaned.substring(1)
  }

  // Проверяем, что в строке ровно 11 цифр (для РФ)
  if (cleaned.length !== 11) {
    return 'Неверный формат номера'
  }

  // Разделяем строку на группы цифр и форматируем
  const match = cleaned.match(/^(\d)(\d{3})(\d{3})(\d{2})(\d{2})$/)

  return `+${match?.[1]} (${match?.[2]}) ${match?.[3]}-${match?.[4]}-${match?.[5]}`
}

export const RUSSIAN_PHONE_REGEX =
  /^(?:\+7|8)?[\s-]?\(?\d{3}\)?[\s-]?\d{3}[\s-]?\d{2}[\s-]?\d{2}$/
